import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_TOKENIZATION_STATUS_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  GetTokenizationStatusRequestPayload,
  GetTokenizationStatusResult,
  TokenizationStatus,
} from '../types/getTokenizationStatus.types';

export const TOKENIZATION_STATUS_TAG = 'TokenizationStatus';
export const getTokenizationStatus = (builder: BuilderType) =>
  builder.query<TokenizationStatus, GetTokenizationStatusRequestPayload>({
    providesTags: [TOKENIZATION_STATUS_TAG],
    query: (params) => ({
      data: params,
      method: 'POST',
      url: GET_TOKENIZATION_STATUS_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetTokenizationStatusResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result.TokenizationStatus;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
